<!-- Skeleton Loader -->
<span class="skeleton" *ngIf="chargingStation.chargingPoints == null">
  •&ensp;•&ensp;•
</span>

<ng-container *ngIf="chargingStation.chargingPoints">
  <div class="status-container">
    <!-- show LOCK icon if charging station is locked -->
    <span *ngIf="!chargingStation.chargingPoints[0].availability && !unregistered" class="badge rounded-pill bg-danger text-white me-2 p-2" [ngbTooltip]="getTooltip(30)">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18" fill="currentColor"><path d="M19 10H20C20.5523 10 21 10.4477 21 11V21C21 21.5523 20.5523 22 20 22H4C3.44772 22 3 21.5523 3 21V11C3 10.4477 3.44772 10 4 10H5V9C5 5.13401 8.13401 2 12 2C15.866 2 19 5.13401 19 9V10ZM5 12V20H19V12H5ZM11 14H13V18H11V14ZM17 10V9C17 6.23858 14.7614 4 12 4C9.23858 4 7 6.23858 7 9V10H17Z"></path></svg>
    </span>

    <!-- charging station reports "not available" - show only chargingStation status -->
    <!-- statusId 2 == ChargingPointStatusEnum.Available -->
    <ng-container *ngIf="chargingStation.statusId != 2; else allPointStatusPills">
      <span [ngClass]="getChargingStationBadgeClasses()"
            [ngbTooltip]="getTooltip(chargingStation.statusId)">
        {{chargingStation.status?.name}}{{this.offlineSinceText}}
      </span>
    </ng-container>

    <!-- charging station reports "available" - list all chargingPoint status -->
    <ng-template #allPointStatusPills>
      <ng-container *ngFor="let chargingPoint of chargingStation.chargingPoints">
        <span [ngClass]="getBadgeClasses(chargingPoint)"
              [ngbTooltip]="getTooltip(chargingPoint)">
          {{getPillContent(chargingPoint)}}
        </span>
      </ng-container>
    </ng-template>
  </div>
</ng-container>
